import Icon from '../Icon';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setPriceHistoryModalOpen } from '../../Actions/PriceHistory.actions';
import PriceModal from '../../Types/PriceModal';

const PriceHistoryModalTrigger = (productPriceHistory: PriceModal) => {
  const { title, previouslyLowestPrice, numberOfDays, description } =
    productPriceHistory;
  const dispatch = useDispatch();
  return (
    <button
      onClick={() =>
        dispatch(
          setPriceHistoryModalOpen(
            true,
            previouslyLowestPrice,
            numberOfDays,
            description,
            title
          )
        )
      }
    >
      <Icon
        className="ml-3 h-5 w-5 cursor-pointer [&_#price-history-icon]:h-5 [&_#price-history-icon]:w-5 [&_#price-history-icon]:cursor-pointer [&_#price-history-icon]:align-top [&_#price-history-icon]:font-normal "
        name="info"
      />
    </button>
  );
};
export default PriceHistoryModalTrigger;
